import { Component, OnInit } from '@angular/core';

import { Motorista } from "../shared/motorista.model";
import { motoristasModuleName } from "../shared/data.service";
import { MotoristaApiService } from "../shared/motorista-api.service";
import { MotoristaNavigationService } from "../shared/motorista-navigation.service";
import { UtilService } from "../../../shared/services/util.service";
import { MotoristaService } from "../shared/motorista.service";

@Component({
  template: require('./motorista-list.component.html'),
  styles: [require('./motorista-list.component.css')]
})
export class MotoristaListComponent implements OnInit {
  list: Motorista[] = [];
  loading: boolean = true;
  showDisabled: boolean = false;
  motoristasModuleName: any = motoristasModuleName;
  
  constructor(
    private _motoristasApiService: MotoristaApiService,
    private _motoristaNavigationService: MotoristaNavigationService,
    private _motoristaService: MotoristaService,
    private _utilService: UtilService
  ) { }

  ngOnInit() {
    this.getAll();
  }

  clickNew() {
    this._motoristaService.clearSessionStorage();
    this._motoristaNavigationService.goToNew();
  }

  clickEdit(item: Motorista) {
    this._motoristaService.clearSessionStorage();
    this._motoristaNavigationService.goToEdit(item.id);
  }

  clickDelete(item: Motorista) {
    var onDelete = (function() {
      this.onDelete(item);
    }.bind(this));

    this._utilService.swalMessageDelete(onDelete);
  }

  private getAll() {
    var onDone = (function(Response: any) {
      if (!Response.error)  {
        this.list = Response;
      }
      this.loading = false;
    }.bind(this));

    this._motoristasApiService.onGetAll(onDone);
  }

  private onDelete(item: any) {
    var onDone = (function(Response: any) {
      if (!Response.error)  {
        var x: number, lenX: number;
        for (x = 0, lenX = this.list.length; x < lenX; x++) {
          if (this.list[x].id === item.id) {
            this.list[x].ativo = false;
            break;
          }
        }
        this._utilService.swalMessageDeleteSuccess();
      } else {
        this._utilService.swalMessageDeleteError();
      }
    }.bind(this));

    this._motoristasApiService.onDelete(item.id, onDone);
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/motoristas/motorista-list/motorista-list.component.ts
 **/